import { globalEnvironment } from '../../../../environments/environment.prod';
import { BaseApplication, BaseApplicationLogo, medicalTag } from 'base';

export const environment = {
  global: globalEnvironment,
  env: 'prod',
  application: {
    project: 'Felten Customer Portal',
    app: BaseApplication.medical,
    tag: medicalTag,
    logo: BaseApplicationLogo.felten,
    logoSmall: BaseApplicationLogo.feltenSmall,
    logoSystemPage: BaseApplicationLogo.felten,
    logoSystemPageSmall: BaseApplicationLogo.feltenSmall,
  },
};
